"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.crewUpdate = exports.onCreate = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var common_1 = require("@main/common");
var common_sidecar_1 = require("@main/common-sidecar");
var diveCrew_hero_data_1 = require("@voyage/crew/diveCrew_hero_data");
var diveCrew_1 = require("@voyage/crew/diveCrew");
var voyageMessageCrewCreate_1 = require("@voyage/multi/voyageMessageCrewCreate");
var voyageMessageCrewCreate_sidecar_1 = require("@voyage/multi/voyageMessageCrewCreate-sidecar");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var diveCrew_hero_sidecar_1 = require("@voyage/crew/diveCrew_hero-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
var voyageFakeInfo_sidecar_1 = require("@voyage/text/voyageFakeInfo-sidecar");
var voyageTilemap_sidecar_1 = require("@voyage/tilemap/voyageTilemap-sidecar");
function onCreate(sys) {
    sys.frozenCrewName = voyageFakeInfo_sidecar_1.voyageFakeInfo.genFakeName_nonDeterministic();
}
exports.onCreate = onCreate;
function crewUpdate(obj) {
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    var d = obj.heroState;
    assert_sidecar_1.assert.notNil(d);
    var useSystemTime = 3;
    d.useSystemTimer += ds;
    diveCrew_hero_sidecar_1.diveCrew_hero.setProgress(obj, d.useSystemTimer / useSystemTime);
    if (d.useSystemTimer > useSystemTime) {
        d.useSystemTimer -= useSystemTime;
        var tHere = voyageTilemap_sidecar_1.voyageTilemap.getSafeIJ(obj);
        assert_sidecar_1.assert.notNil(tHere);
        var sd = tHere.system;
        assert_sidecar_1.assert.notNil(sd);
        if (sd.ammo > 0) {
            sd.ammo--;
            if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
                var id = common_1.createId();
                voyageMessageCrewCreate_sidecar_1.voyageMessageCrewCreate.sendMessageAndImmediatelyExecute({
                    crewId: id,
                    type: diveCrew_1.EVoyageCrewType.Hero,
                    heroType: diveCrew_hero_data_1.EDiveHeroSubtype.None,
                    enemyType: '',
                    i: tHere.i,
                    j: tHere.j + 1,
                    method: voyageMessageCrewCreate_1.EVoyageCrewCreateMethod.Normal,
                    team: 0,
                    name: sd.frozenCrewName,
                    energy: diveCrew_sidecar_1.diveCrew.maxEnergy,
                    hitpoints: 50,
                });
                // Transfer name
                // let cr = diveCrew.findById(id)
                // assert.notNil(cr)
                // cr.name = sd.frozenCrewName || cr.name
            }
        }
        else {
            diveCrew_sidecar_1.diveCrew.say(obj, 'Cryo chamber is empty');
        }
    }
}
exports.crewUpdate = crewUpdate;
